import React, { useEffect, useState, useContext, useMemo } from "react";
import { Typography, Box, Backdrop, CircularProgress, InputAdornment, FormControl, InputLabel, TextField, Select, MenuItem, Button, Stack, TableCell, tableCellClasses, styled, IconButton, Dialog, AppBar, Toolbar, Checkbox} from "@mui/material";
import { Search, Edit, InsertDriveFileOutlined, Close, History, Flaky, RemoveCircleOutline } from '@mui/icons-material';
import Header from "../ui/Header";
import SorTable from "../ui/sortable";
import { API } from "../../conf";
import { Context } from "../../App";
import moment from 'moment';
import DepenseHistory from "../sections/depense-history";
import RegistDepense from "../../pages/register-depense";
import Graph from "../ui/graph";
import CancelDepense from "../forms/cancelDepense";
import theme from "../../theme";

export default function JrnDepenses() {
    const { updateConnect } = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    
    const editCol = {header: "", sortable: false, row: (row, index)=> <StyledTableCell key={index} sx={{minWidth:'180px'}} >
        {!row.isCanceled && !row.isCancelLog && <IconButton aria-label="modifier" disabled={row.is_cloture||agent.level>2} onClick={()=>{setDepense(row);manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>}
        {!row.isCanceled && !row.isCancelLog && <IconButton aria-label="Edit facture" disabled={row.facture.length<=0} onClick={()=>{setDepense(row); manage_dialog(true, 'facture')}}><InsertDriveFileOutlined fontSize="small"/></IconButton>}
        {/* <IconButton aria-label="imprimer" onClick={()=>print_facture(row)}><PrintOutlined fontSize="small"/></IconButton> */}
        {!row.isCancelLog && <IconButton aria-label="historique" onClick={()=>{setDepense(row);manage_dialog(true, 'info')}}><History fontSize="small"/></IconButton>}
        {!row.isCanceled && !row.isCancelLog && row.to_controlle&&agent.level!==3&&<IconButton aria-label="controlle" onClick={()=>{setDepense(row);manage_dialog(true, 'controlle')}}><Flaky fontSize="small"/></IconButton>}
        {!row.isCanceled && !row.isCancelLog && (!row.is_cloture||agent.level>2)&&<IconButton aria-label="annulation" onClick={()=>{setDepense(row);manage_dialog(true, 'annulation')}}><RemoveCircleOutline fontSize="small"/></IconButton>}
        {row.isCanceled&&<span style={{fontSize: '14px', fontStyle:'italic', fontWeight: 'bold', color: theme.palette.error.main}}>Dépense annulée</span>}
    </StyledTableCell>}

    const checkColumn = {header: "Vérifiée", sortable: true, sortBy:el=>el.check?1:0, row: (row, index)=><StyledTableCell key={index} align="center"><Checkbox checked={row.check} onChange={()=>handleCheck(row)} /></StyledTableCell>}
    
    const columns = (cpts) => [
        {header: "Date", sortable: true, sortBy:(el)=>new Date(el.date).getTime(), row: (row, index)=><StyledTableCell key={index} align="center" sx={{color: row.isCanceled ? 'gray' : 'inherit'}}>{moment.utc(row.date).format('DD/MM/YYYY')}</StyledTableCell>},
        {header: "Libellé", sortable: true, sortBy:el=>el.libelle.toLowerCase(), row: (row, index)=><StyledTableCell key={index} sx={{minWidth:'150px', color: row.isCanceled ? 'gray' : 'inherit'}} align="center">{row.libelle}</StyledTableCell>},
        {header: "Classification", sortable: true, sortBy:el=>el.class?.toLowerCase(), row: (row, index)=><StyledTableCell key={index} sx={{minWidth:'150px', color: row.isCanceled ? 'gray' : 'inherit'}} align="center">{row.class}</StyledTableCell>},
        {header: "Fournisseur", sortable: true, sortBy:el=>el.fournisseur?.toLowerCase(), row: (row, index)=><StyledTableCell key={index} align="center" sx={{minWidth:'120px', color: row.isCanceled ? 'gray' : 'inherit'}}>{row.fournisseur}</StyledTableCell>},
        {header: "N° facture", sortable: true, sortBy:el=>el.num_facture?.toLowerCase(), row: (row, index)=><StyledTableCell key={index} sx={{minWidth:'100px', color: row.isCanceled ? 'gray' : 'inherit'}} align="center">{row.num_facture}</StyledTableCell>},
        {header: "Mode de paiement", sortable: true, sortBy:el=>el.paymode.especes>0?1:el.paymode.cheques.length>0?2:3, row: (row, index)=><StyledTableCell key={index} align="center" sx={{minWidth:'150px', color: row.isCanceled ? 'gray' : 'inherit'}}>
            {row.paymode.especes>0&&<Typography fontSize={14}>Espèces: {row.paymode.especes.toFixed(2)}€</Typography>}
            {row.paymode.cheques.length>0&&<Typography fontSize={14}>{row.paymode.cheques.length} chèque(s): {row.paymode.cheques.reduce((tt, cq)=>tt+cq.montant,0).toFixed(2)}€</Typography>}
            {row.paymode.virement&&<Typography fontSize={14}>Virement: {row.paymode.virement.montant.toFixed(2)}€</Typography>}
            {row.paymode.prelevement&&<Typography fontSize={14}>Prélèvement: {row.paymode.prelevement.montant.toFixed(2)}€</Typography>}
        </StyledTableCell>},
        {header: "Compte débité", sortable: true, sortBy:(el)=>cpts.find(cpt=> el.comptes.includes(cpt.num))?.libelle.toLowerCase(), 
            row: (row, index)=><StyledTableCell key={index} align="center" sx={{textTransform:'capitalize', minWidth:'150px', color: row.isCanceled ? 'gray' : 'inherit'}}>
                {cpts.find(cpt=> row.comptes.includes(cpt.num))?.libelle}
            </StyledTableCell>},
        {header: "Montant", sortable: true, sortBy:el=>el.montant, row: (row, index)=><StyledTableCell key={index} align="right" sx={{color: row.isCanceled ? 'gray' : 'inherit'}}>{row.montant.toFixed(2)}€</StyledTableCell>},
    ]
    const montant_columns = [
        {header: "Mode de paiement", search: row=>row.paymode.especes?.toFixed(2)+' '+(row.paymode.cheques.length>0?row.paymode.cheques.reduce((tt, cq)=>tt+cq.montant,0).toFixed(2)+' ':'')+' '+row.paymode.virement?.montant.toFixed(2)},
        {header: "Montant", search:(el)=>el.montant.toFixed(2)},
    ]
    const [selectedCol, setSelectCol] = useState(["Date", "Libellé", "Fournisseur", "Mode de paiement", "Compte débité", "Montant"])
    const [selectedMCol, setSelectMCol] = useState(["Montant"])
    const [loading, setLoad] = useState(true)
    const [min_date, setMin] = useState()
    const [max_date, setMax] = useState()
    const [start_date, setStart] = useState('')
    const [end_date, setEnd] = useState('')
    const [search_input, setSearch] = useState('')
    const [montant, setMontant] = useState('')
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')
    const [depenses, setDepenses] = useState()
    const [depense, setDepense] = useState()
    const [comptes, setComptes] = useState()
    const [pdf, setPdf] = useState()
    const [img, setImg] = useState()
    const [dial_open, setDopen] = useState(false)
    const [table, setTable] = useState([])

    const eglise = useMemo(()=>{
        if (organisation && organisation.type==='église') {
            return organisation
        } else if (egliseId!=='') {
            return eglises.find(el=> el._id === egliseId)
        } else return
    }, [eglises, egliseId, organisation])

    function handleCheck(row) {
        const query = new URLSearchParams({_id: row._id, check: !row.check}).toString()
        setLoad(true)
        fetch(API.concat(`/depenses/check?${query}`), { 
            method:'PATCH',
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', token)
                }
                if (response.ok) {
                    setDepenses(depenses.map(el=>el._id===row._id?{...el, check: !el.check}:el))
                }
            }
            setLoad(false)
        })
    }

    function create_facture(index) { return new Promise((resolve, reject) => {
        fetch(API.concat(`/depenses/download/${depense._id}/${index}`), {
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const blob = await response.blob()
                    resolve(URL.createObjectURL(blob))
                }else resolve('')
            }
        })
    })}

    function get_facture(index) {
        setLoad(true)
        const filepath = depense.facture[index]
        create_facture(index).then(url=>{
            if (filepath.slice(filepath.lastIndexOf('.'))==='.pdf') {
                setPdf(url); setImg()
            }else {
                setImg(url); setPdf()
            }
            setLoad(false)
        })
    }

    function print_facture(depense) {
        setLoad(true)
        create_facture(depense).then(pdf_url=>{
            const win = window.open(pdf_url, '_blank');
            if (win) {
                win.onload = function() {win.print()};
            } else {
                alert('Impossible d\'ouvrir le PDF et de l\'imprimer');
            }
            setLoad(false)
        })
    }

    function manage_dialog(status, action) {
        setDopen(status)
        setAction(action)
        if (!status) {
            setDepense()
            setPdf(); setImg()
        }
    }

    async function getCanceledDepenses(end_date, start_date) {
        setLoad(true)
        const response = await fetch(API.concat(`/logs/depenses/by`), {
            method:'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({eglise: eglise.number, action: 'annulation dépense', end_date, start_date})
        })

        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
            sessionStorage.clear()
            updateConnect(false)
        }else {
            if (token && token !== sessionStorage.getItem('token') && token !== '') {
                sessionStorage.setItem('token', response.headers.get('x-auth-token'))
            }
            
            if (response.status === 200) {
                const json = await response.json();
                const canceledDepenses = json.map(log=>[
                    {...log.whatObj, isCanceled:true, color:'rgba( 188, 201, 199, 0.5)', hoverColor:'rgba( 188, 201, 199, 0.8)'},
                    {...log.whatObj, isCancelLog:true, date: log.when, libelle: 'Annulation dépense "' + log.whatObj.libelle + '"' , montant: +log.whatObj.montant, color:'rgba( 150, 3, 26, 0.8)', hoverColor:'rgba( 150, 3, 26, 0.5)'}
                ]).flat();
                setLoad(false)
                return(canceledDepenses);
            } else {
                setLoad(false)
                return([]);
            }
        }
    }

    function get_depenses(end_date, start_date) {
        setLoad(true)
        fetch(API.concat(`/depenses/agent/by/${JSON.stringify({eglise: eglise.number, $and: [{date: {$lte: new Date(moment.utc(end_date).add(1, 'days').toDate())}}, { date: {$gte: new Date(start_date)}}]})}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    const canceled = await getCanceledDepenses(end_date, start_date)
                    const sorted = [...json, ...canceled].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                    setDepenses(sorted)

                    fetch(API.concat(`/comptes/by`), {
                        method:'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                        }, body: JSON.stringify({num:{$in:[...new Set(json.map(dep=>dep.comptes).flat())]}, type:{$nin: ['petite-caisse', 'banque']}, eglise: eglise.number})
                    }).then(async response=>{
                        const token = response.headers.get('x-auth-token')
                        if(response.status === 401) {
                            sessionStorage.clear()
                            updateConnect(false)
                        }else {
                            if (token && token !== sessionStorage.getItem('token') && token !== '') {
                                sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                            }
                            if (response.status === 200) {
                                const cpts = await response.json()
                                setComptes(cpts);
                                setTable(selectedCol.map(header=> columns(cpts).find(col=> col.header===header)))
                                setLoad(false)
                            }else setLoad(false)
                        }
                    })
                }else setLoad(false)
            }
        })
    }

    function controlle_depense(validated) {
        setLoad(true)
        fetch(API.concat(`/depenses/control/${depense._id}`), {
            method:'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({validated, to_controlle: false})
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setDepenses(old=>old.map(dep=>dep._id===json._id?json:dep))
                    manage_dialog(false, '')
                }
                setLoad(false)
            }
        })
    }

    function get_lineargraph_data() {
        const dates = [...new Set(depenses.map(dep=>dep.date))]
        let data = comptes.map(cpt=>({label:cpt.libelle, values: dates.map(date => depenses.filter(dep=> dep.date===date&&dep.comptes.includes(cpt.num)).reduce((tt,cdep)=>tt+cdep.montant, 0))}))
        return {dates, data}
    }

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(dep) {
        return dep.libelle+' '+dep.class+' '+dep.fournisseur+' '+dep.num_facture+' '+(dep.paymode.especes>0?'espèces ':'')+(dep.paymode.cheques.length>0?'chèques ':'')+(dep.paymode.virement?'virements ':'')+' '+comptes.find(cpt=> dep.comptes.includes(cpt.num))?.libelle
    }

    function get_Msearchable(dep) {
        return selectedMCol.reduce((all, current)=> all+montant_columns.find(col=> col.header===current)?.search(dep)+' ','')
    }

    useEffect(()=>{
        if(eglise?.number){
            const minDate = moment.utc().startOf('year').add(-1, 'year').toDate()
            setMin(minDate); setMax(new Date()); 
            setEnd(moment.utc(Date.now()).format('yyyy-MM-DD'))
            const month_before = moment.utc().add(-1,'month')
            setStart(month_before.format('yyyy-MM-DD'))
            get_depenses(new Date(), month_before)
        }
    }, [eglise?._id])

    useEffect(()=>{}, [table, selectedMCol, comptes])

    useEffect(()=>{
        if (organisation&&organisation.type==='fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:{type:'église'})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[]) 

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
    }));     
    
    return(
        <div style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Journal des Dépenses</Typography>
            {organisation&&organisation.type==='fédération'&&<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(old=>{if(old!==e.target.value)setDepenses([]); return e.target.value})}>
                {eglises.sort((a,b)=>a.nom.toLowerCase()<b.nom.toLowerCase() ? -1 : 1).map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}
            <Box sx={{paddingX:'20px', marginTop:'30px'}}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                    <Stack direction='row' spacing={2} sx={{alignItems:'center'}}>
                        <Typography fontWeight={600} fontSize={16}>Période:</Typography>
                        <TextField
                        size="small"
                        margin="normal"
                        sx={{minWidth:'90px'}}
                        InputLabelProps={{shrink: true}}
                        label="Date de début"
                        type='date'
                        value={start_date}
                        inputProps={min_date&&max_date&&{min: new Date(min_date).toISOString().split("T")[0], max: new Date(max_date).toISOString().split("T")[0]}}
                        onChange={(event)=> {
                            setStart(event.target.value)
                            if (end_date!=='' && (new Date(end_date).getTime() - new Date(event.target.value).getTime()) < 0) {
                                setEnd('')
                            } 
                        }}
                        />
                        <TextField
                        size="small"
                        margin="normal"
                        sx={{minWidth:'90px'}}
                        InputLabelProps={{shrink: true}}
                        label="Date de fin"
                        type="date"
                        value={end_date}
                        inputProps={min_date&&max_date&&{min: new Date(start_date!=='' ? start_date : min_date).toISOString().split("T")[0], max: new Date(max_date).toISOString().split("T")[0]}}
                        onChange={(event)=> {
                            setEnd(event.target.value)
                            if (start_date!=='' && (new Date(event.target.value).getTime() - new Date(start_date).getTime()) < 0) {
                                setStart('')
                            }
                        }}
                        />
                        <Button variant="contained" disabled={start_date===''||end_date===''||!eglise} onClick={()=>get_depenses(end_date, start_date)}>Appliquer</Button>
                    </Stack>
                    <Button variant="contained" onClick={()=> {manage_dialog(true, 'graph')}} disabled={!depenses?.length>0}>Graph</Button>
                </div>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:'20px'}}>
                    <TextField
                    size="small"
                    label="Rechercher une dépense par libellé, classification, fournisseur, n° facture, mode de paiement et compte débité"
                    InputLabelProps={{sx:{width:'90%'}}}
                    disabled={!depenses?.length>0}
                    sx={{width:'60%', minWidth:'300px'}}
                    value={search_input}
                    InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Search />
                          </InputAdornment>
                        ),
                    }}
                    onChange={(event)=> setSearch(event.target.value)}
                    />
                    <FormControl sx={{ m: 1, width:'30%', minWidth: '250px' }}>
                        <InputLabel>Colonnes</InputLabel>
                        <Select
                        size="small"
                        multiple
                        renderValue={(selected) => selected.join(', ')}
                        sx={{ width:'100%', minWidth:'250px', maxWidth:'500px'}}
                        label="Colonnes"
                        open={open}
                        onOpen={()=>setOpen(true)}
                        onClose={()=>setOpen(false)}
                        value={selectedCol}
                        onChange={(e)=>setSelectCol(e.target.value.flat().length>columns([]).length ? columns([]).map(col=> col.header) : e.target.value.flat())}
                        >
                            <MenuItem value={columns([]).map(col=> col.header)} sx={{justifyContent:'center'}}>
                                <Typography fontWeight='bold'>Tout sélectionner</Typography> 
                            </MenuItem>
                            {columns([]).map((col, index) => (
                                <MenuItem key={index} value={col.header}>
                                    <Typography>{col.header}</Typography> 
                                </MenuItem>
                            ))}
                            <div style={{display:'flex', justifyContent:'space-around', alignItems:'center', marginTop:8, paddingInline:'10px'}}>
                                <Button variant="outlined" sx={{ textTransform:'none', fontWeight:'400', paddingY:'1px', width:'100%', marginRight:'5px' }} onClick={()=>setSelectCol([])}>Effacer</Button>
                                <Button variant="contained" sx={{ textTransform:'none', fontWeight:'400', paddingY:'1px', width:'100%', marginLeft:'5px' }} onClick={()=>{setOpen(false); setTable(selectedCol.map(header=> columns(comptes).find(col=> col.header===header)))}}>Appliquer</Button>
                            </div> 
                        </Select>
                    </FormControl>
                </div>
                <div style={{display:'flex', alignItems:'center'}}>
                    <TextField
                    label="Rechercher un montant"
                    size="small"
                    type="number"
                    disabled={!depenses?.length>0}
                    sx={{width:'25%', minWidth:'250px', maxWidth:'350px', marginRight:'5px'}}
                    value={montant}
                    InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Search />
                          </InputAdornment>
                        ),
                    }}
                    onChange={(event)=>{
                        if (event.target.value.split('.').length<2 || !(event.target.value.split('.')[1]?.length>2)) {
                            setMontant(event.target.value)  
                        } 
                    }}
                    />
                    <Typography variant="body1">dans</Typography>
                    <FormControl sx={{ m: 1, width:'30%', minWidth: '250px' }}>
                        <InputLabel>Champs</InputLabel>
                        <Select
                        size="small"
                        multiple
                        renderValue={(selected) => selected.join(', ')}
                        sx={{ width:'100%', minWidth:'250px', maxWidth:'500px'}}
                        label="Colonnes"
                        value={selectedMCol}
                        onChange={(e)=>setSelectMCol(e.target.value.flat())}
                        >
                            {montant_columns.map((col, index) => (
                                <MenuItem key={index} value={col.header}>
                                    <Typography>{col.header}</Typography> 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                
                {depenses && comptes && <SorTable data={depenses.filter(dep=> normalize(get_searchable(dep)).includes(normalize(search_input))&&(montant?.length>0&&selectedMCol.toString()!==''&&selectedMCol.toString()!==' ' ? get_Msearchable(dep).includes(montant): true))} table={[agent.level>2 ? checkColumn : null, ...table.concat([editCol])].filter(Boolean)} rowsPerPage={25} rowsPerPageOptions={[10, 25, 50, 100]}/>}
            </Box>

            <Backdrop open={loading}><CircularProgress color="inherit" /></Backdrop>

            <Dialog fullScreen={action==='edit'} open={dial_open} onClose={()=>manage_dialog(false, '')} maxWidth={['controlle', 'annulation'].includes(action)?'xs':'md'} fullWidth PaperProps={{sx : {overflow: action==='pdf'?'hidden':'auto'}}} >
                {action !== 'edit' && <IconButton sx={{alignSelf:'end', top:'5px', right:'5px'}} onClick={()=>{manage_dialog(false, '')}}><Close/></IconButton>}
                {action==='info' && depense && <DepenseHistory {...{eglise, depense}} />}
                {action==='facture' &&depense&&<Box display='flex' flexDirection='column' margin='20px 10px'> 
                    <Typography variant="h5" align="center" marginBottom='20px'>Facture</Typography>
                    <TextField select sx={{minWidth:'300px', width:'60%', alignSelf:'center', marginBottom:'20px'}} label='Fichier' onChange={e=>{get_facture(e.target.value)}}>
                        {depense.facture.map((file, index)=><MenuItem key={index} value={index}>{file.slice(file.lastIndexOf(`\\`)+1)}</MenuItem>)}
                    </TextField>
                    {pdf && <embed src={pdf} width='100%' height='600px' type="application/pdf" />}
                    {img && <img src={img} style={{width:'100%', height:'600px'}} loading="lazy" alt="facture" />}
                </Box>}
                {action==='edit' && depense && <Box display='flex' flexDirection='column' flex={1} >
                    <AppBar sx={{ position: 'relative' }} color="grey">
                    <Toolbar>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        Modification
                        </Typography>
                        <Button autoFocus color="inherit" onClick={()=>{manage_dialog(false, '')}}>
                        Fermé
                        </Button>
                    </Toolbar>
                    </AppBar>

                    <RegistDepense edit={true} depense={depense} setDepenses={edited=>setDepenses(old=>[...old.filter(dep=> dep._id!==edited._id), edited])} close={()=> manage_dialog(false, '')} />
                </Box>}
                {action==='graph' && <Graph data={comptes.map(cpt=>({label:cpt.libelle, value: depenses.filter(dep=>dep.comptes.includes(cpt.num)).reduce((tt, current)=>tt+current.montant,0)}))}
                tt_label='Total'
                line_data = {get_lineargraph_data()}/>}

                {action==='controlle' && depense && <Box display='flex' flexDirection='column' flex={1}>
                    <Typography variant="h6" align="center" marginBottom='20px'>Validez-vous la comptabilisation de cette dépense dans votre trésorerie ?</Typography>
                    <Stack direction='row' spacing={2} sx={{alignItems:'center', justifyContent:'center', marginBottom:'20px'}}>
                        <Button variant="contained" onClick={()=>{manage_dialog(false, ''); controlle_depense(true)}}>Oui, Comptabiliser</Button>
                        <Button variant="contained" color="carmine" onClick={()=>{manage_dialog(false, ''); controlle_depense(false)}}>Non, Refuser</Button>
                    </Stack>
                </Box>}
                {action==='annulation' && depense && <CancelDepense {...{depense, setLoad, 
                    updateDepenses: (log) => setDepenses(old => old.map(dep => dep._id !== depense._id ? dep : [{...dep, isCanceled:true, color:'rgba( 188, 201, 199, 0.5)', hoverColor:'rgba( 188, 201, 199, 0.8)'}, {...dep, date: log.when, libelle: 'Annulation dépense "' + depense.libelle + '"' , montant: -depense.montant, color:'rgba( 150, 3, 26, 0.8)', hoverColor:'rgba( 150, 3, 26, 0.5)'}]).flat()), 
                    onCancel:() => manage_dialog(false, '')}}/>}
            </Dialog>
        </div>
    )
}